import * as React from "react";
function SvgClock(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <circle
        cx={16}
        cy={16}
        r={15}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M15 7v10h7"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgClock);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
